import React from 'react';
import { SortableElement, SortableHandle } from 'react-sortable-hoc';
import UploadButton from '../UploadButton';
import Input from '../Input';

const Draggable = SortableHandle((props) => {
    return (
        <div className="drag-point">
            <i className="fas fa-sort"></i>
        </div>
    )
});

const Sortable = SortableElement(props => {
    return (
        <div className="sortable-item col-6">
            <div className="d-flex">
                <div>
                    <Draggable {...props} />
                    <div className="delete-point" index={props.itemIndex} onClick={props.deleteButtonHandler}>
                        <i className="far fa-trash-alt"></i>
                    </div>
                </div>
                <div className="col">
                    <div className="card my-2 p-2">
                        <div className="form-group">
                            <label>Заголовок</label>
                            <Input name={`elements.${props.itemIndex}.title`}
                                   value={props.element.title} onChange={props.onChange}/>
                        </div>
                        <div className="form-group">
                            <label>Подзаголовок</label>
                            <Input name={`elements.${props.itemIndex}.subTitle`}
                                   value={props.element.subTitle} onChange={props.onChange}/>
                        </div>
                        <div className="form-group d-flex">
                            <div>
                                <label>Изображение</label>
                                <div className="images">
                                    <div className="img-container">
                                        <div className="img-wrap">
                                            <img src={props.element.img}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="pt-3">
                                <UploadButton name={`elements.${props.itemIndex}.img`}
                                              index={props.itemIndex} onChange={props.onChange}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
})

export default Sortable;
